import React from 'react'
import { View, StyleSheet } from 'react-native'
import { useSelector } from 'react-redux'

import MainTasksView from '../TaskListView/MainTasksView'
import ContactsView from '../ContactsView/ContactsView'
import GoalsView from '../GoalsView/GoalsView'
import RootViewFeedsGlobalProject from '../Feeds/RootViewFeedsGlobalProject'
import NotesView from '../NotesView/NotesView'
import {
    DV_TAB_ROOT_CONTACTS,
    DV_TAB_ROOT_GOALS,
    DV_TAB_ROOT_NOTES,
    DV_TAB_ROOT_TASKS,
    DV_TAB_ROOT_UPDATES,
    DV_TAB_ROOT_CHATS,
    DV_TAB_ROOT_WIKI,
    DV_TAB_ROOT_ARTIFACTS,
} from '../../utils/TabNavigationConstants'
import ChatsView from '../ChatsView/ChatsView'
import WikiView from '../WikiView/WikiView'
import ArtifactsView from '../ArtifactsView/ArtifactsView'
import CustomScrollView from '../UIControls/CustomScrollView'
import useCollapsibleSidebar from '../SidebarMenu/Collapsible/UseCollapsibleSidebar'
import { SIDEBAR_MENU_COLLAPSED_WIDTH } from '../styles/global'
import RootSectionNavigation from './RootSectionNavigation'
import { checkIfSelectedAllProjects } from '../SettingsView/ProjectsSettings/ProjectHelper'
import ConnectionStatusChip from '../TopBar/ConnectionStatusChip'
import { showConnectionChipBelowHeader } from '../TopBar/connectionChipPlacement'
import FloatingAddTaskButton from '../TaskListView/FloatingAddTaskButton'

export const isMainViewScrollEnabled = state => !(state.smallScreen && state.showFloatPopup > 0)

export default function MainViewsContainer() {
    const selectedTab = useSelector(state => state.selectedSidebarTab)
    const selectedProjectIndex = useSelector(state => state.selectedProjectIndex)
    const enableScroll = useSelector(isMainViewScrollEnabled)
    // smallScreen is the <= 970px content breakpoint, which covers phone, tablet,
    // and compact desktop layouts. React Native Web blocks touch/wheel events here.
    // The connection chip uses its own, narrower band (AT-2426) — see
    // `showConnectionChipBelowHeader`.
    const chipBelowHeader = useSelector(showConnectionChipBelowHeader)

    const { overlay } = useCollapsibleSidebar()
    const showGlobalRootSectionNavigation = checkIfSelectedAllProjects(selectedProjectIndex)

    return (
        <CustomScrollView
            nativeID="main-task-list-viewport"
            style={[localStyles.subContainer, overlay && { marginLeft: SIDEBAR_MENU_COLLAPSED_WIDTH }]}
            scrollEnabled={enableScroll}
            fixedChildren={selectedTab === DV_TAB_ROOT_TASKS ? <FloatingAddTaskButton /> : null}
        >
            <View>
                {chipBelowHeader && <ConnectionStatusChip belowHeader />}
                {showGlobalRootSectionNavigation && <RootSectionNavigation />}
                {(() => {
                    switch (selectedTab) {
                        case DV_TAB_ROOT_TASKS:
                            return <MainTasksView />
                        case DV_TAB_ROOT_NOTES:
                            return <NotesView />
                        case DV_TAB_ROOT_GOALS:
                            return <GoalsView />
                        case DV_TAB_ROOT_CONTACTS:
                            return <ContactsView />
                        case DV_TAB_ROOT_CHATS:
                            return <ChatsView />
                        case DV_TAB_ROOT_UPDATES:
                            return <RootViewFeedsGlobalProject />
                        case DV_TAB_ROOT_WIKI:
                            return <WikiView />
                        case DV_TAB_ROOT_ARTIFACTS:
                            return <ArtifactsView />
                    }
                })()}
            </View>
        </CustomScrollView>
    )
}

const localStyles = StyleSheet.create({
    subContainer: {
        flex: 1,
    },
})
